module.exports = __webpack_public_path__ + "img/9.b503f7b6.jpg";